import styled from '@emotion/styled';

import CondensedTable from 'components/CondensedTable/CondensedTable';

export const OfferPaymentsTable = styled(CondensedTable)`
  .ant-table-row.added-payment {
    .ant-table-cell {
      background-color: var(--purple-10);
    }
    &:hover .ant-table-cell {
      background-color: var(--purple-9);
    }
  }
  .ant-table-row.modified-payment {
    .ant-table-cell {
      background-color: var(--yellow-10);
    }
    &:hover .ant-table-cell {
      background-color: var(--yellow-9);
    }
  }
  .ant-table-row.removed-payment {
    .ant-table-cell {
      background-color: var(--red-10);
      text-decoration: line-through;
      color: var(--color-text-quaternary);
    }
    &:hover .ant-table-cell {
      background-color: var(--red-9);
    }
  }
`;

const ROW_CLASS = {
  add: 'added-payment',
  edit: 'modified-payment',
  delete: 'removed-payment',
};

export const applyRowClass = (payment) =>
  ROW_CLASS[payment.changeType ?? payment.status] ?? '';
